import { useTranslation } from "next-i18next";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";

const SecureAndUniqueVirtualServers = () => {
    const { t } = useTranslation(["common", "windowsCloudServer"]);
    const [activeSection, setActiveSection] = useState(1);
    const containerRef = useRef(null);

    const titleRef = useRef(null);
    const title2Ref = useRef(null);
    const title3Ref = useRef(null);

    const sections = [
        { id: 1, title: t("common:makdosUniqueConfigurationOptions") },
        { id: 2, title: t("common:maximizeYourSecurityWithMakdos") },
        { id: 3, title: t("common:makdosSSLVPNAndAdditionalFeatures") },
    ];

    useEffect(() => {
        const handleScroll = (e) => {
            const containerBox = containerRef.current;
            const title = titleRef.current;
            const title2 = title2Ref.current;
            const title3 = title3Ref.current;

            const scroll = containerBox.scrollTop;

            const titleTop = title.getBoundingClientRect().top - containerBox.getBoundingClientRect().top;
            const title2Top = title2.getBoundingClientRect().top - containerBox.getBoundingClientRect().top;
            const title3Top = title3.getBoundingClientRect().top - containerBox.getBoundingClientRect().top;

            if (scroll >= titleTop && scroll < title2Top) {
                setActiveSection(1);
            } else if (scroll >= title2Top && scroll < title3Top) {
                setActiveSection(2);
            } else if (scroll >= title3Top) {
                setActiveSection(3);
            }
        }

        const container = containerRef.current;
        container.addEventListener("scroll", handleScroll);

        return () => {
            container.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <div className="container px-4 py-10 mx-auto lg:py-20 lg:px-0">
            <h2 className="font-semibold text-3xl mb-3 lg:text-[40px] lg:text-center text-textGray">{t("common:secureAndUniqueVirtualServers")}</h2>
            <div className="text-sm lg:text-base lg:text-center text-textGray mx-auto lg:mx-[150px]"
                dangerouslySetInnerHTML={{ __html: t("common:secureAndUniqueVirtualServersDesc") }}>
            </div>

            <div className="grid grid-cols-2 gap-10 mt-20">
                <div ref={containerRef} className="lg:h-[405px] col-span-2 lg:col-span-1 overflow-y-auto customScroll pr-4">
                    <h3 className="text-xl lg:text-[24px] font-bold mb-4" ref={titleRef} >
                        {sections[0].title}
                    </h3>
                    <p className="text-lg leading-relaxed text-gray-600">
                        {t("common:makdosUniqueConfigurationOptionsDesc")}
                    </p>
                    <ul className="mt-4 space-y-2.5 text-gray-600">
                        <li>{t("common:makdosUniqueConfigurationOptionsDesc2")}</li>
                        <li>{t("common:makdosUniqueConfigurationOptionsDesc3")}</li>
                        <li>{t("common:makdosUniqueConfigurationOptionsDesc4")}</li>
                        <li>{t("common:makdosUniqueConfigurationOptionsDesc5")}</li>
                        <li>{t("common:makdosUniqueConfigurationOptionsDesc6")}</li>
                        <li>{t("common:makdosUniqueConfigurationOptionsDesc7")}</li>
                    </ul>

                    <h3 className="text-xl lg:text-[24px] font-bold mb-4 mt-10" ref={title2Ref}>
                        {sections[1].title}
                    </h3>
                    <div className="text-lg leading-relaxed text-gray-600"
                        dangerouslySetInnerHTML={{ __html: t("common:maximizeYourSecurityWithMakdosDesc") }}>
                    </div>

                    <h3 className="text-xl lg:text-[24px] font-bold mb-4 mt-10" ref={title3Ref}>
                        {sections[2].title}
                    </h3>
                    <div className="text-lg leading-relaxed text-gray-600"
                        dangerouslySetInnerHTML={{ __html: t("common:makdosSSLVPNAndAdditionalFeaturesDesc") }}>
                    </div>
                </div>

                {/* Sağ: Çizgi ve Görsel */}
                <div className="relative hidden lg:grid">
                    <div className="absolute left-0 flex flex-col justify-between h-full">
                        <div className={`${activeSection === 1 ? "opacity-100" : "opacity-0"} transition-all duration-300`}>
                            <Image src="/line1.svg" width={194} height={59} title={t("windowsCloudServer:secureAndUniqueVirtualServersWithMakdos")} alt={t("windowsCloudServer:secureAndUniqueVirtualServersWithMakdos")} />
                        </div>
                        <div className={`${activeSection === 2 ? "opacity-100" : "opacity-0"} transition-all duration-300`} >
                            <Image src="/line2.svg" width={81} height={18} title={t("windowsCloudServer:secureAndUniqueVirtualServersWithMakdos")} alt={t("windowsCloudServer:secureAndUniqueVirtualServersWithMakdos")} />
                        </div>
                        <div className={`${activeSection === 3 ? "opacity-100" : "opacity-0"} transition-all duration-300`}>
                            <Image src="/line3.svg" width={185} height={58} title={t("windowsCloudServer:secureAndUniqueVirtualServersWithMakdos")} alt={t("windowsCloudServer:secureAndUniqueVirtualServersWithMakdos")} />
                        </div>
                    </div>

                    <div className="flex items-center justify-center">
                        <Image
                            src="/secureAndUniqueVirtualServer.svg"
                            width={350}
                            height={350}
                            alt={t("windowsCloudServer:secureAndUniqueVirtualServersWithMakdos")}
                            title={t("windowsCloudServer:secureAndUniqueVirtualServersWithMakdos")}
                        />
                    </div>
                </div>
            </div>
        </div>

    )
}

export default SecureAndUniqueVirtualServers